import { createAction, props } from '@ngrx/store';
import { ClientCurrentUser } from '../../data-model/models/client-current-user.model';

const feature = '[Auth]';

/**
 * sign in
 */
export const signIn = createAction(`${feature} Sign In`, props<{ username: string; password: string }>());
export const signedIn = createAction(`${feature} Signed In`, props<{ currentUser: ClientCurrentUser; apiToken: string; username: string; password: string }>());

/**
 * sign out
 */
export const signOut = createAction(`${feature} Sign Out`);
export const signedOut = createAction(`${feature} Signed Out`);

/**
 * client version
 */
export const validateClientVersion = createAction(`${feature} Validate Client Version`);
export const clientVersionValidated = createAction(`${feature} Client Version Validated`);

/**
 * reset state
 */
export const resetAuthState = createAction(`${feature} Reset Auth State`);
